import Card from './Card';
import CardBody from './CardBody';
import CardHeader from './CardHeader';
import CardSubHeader from './CardSubHeader';

export default Object.assign(Card, {
  Header: CardHeader,
  SubHeader: CardSubHeader,
  Body: CardBody,
});
